import { Component, OnInit, OnDestroy, Input, Optional, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { TradingService } from '../../services/common/trading-service.service';
import { Account } from '../../models/common/trading-common.model';
import { Holdings, HoldingsTotal } from '../../models/common/trading-holdings';
import es from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
@Component({
  selector: 'holdings-mini',
  templateUrl: './holdings-mini.component.html',
  styleUrls: ['./holdings-mini.component.css']
})
export class HoldingsMiniComponent implements OnInit, OnDestroy {
  @Input() platform: string;
  @Input() isForSecondSymbol: boolean = false;
  accountSub: Subscription;
  holdingSub: Subscription;
  account: Account;
  symbols: string[] = [];
  symbolSub: Subscription;
  positions: Holdings[];
  positionsForDisplay = [];
  valueCurrency: string;
  showMktValInPositionCcy: boolean = false;
  hasError: boolean = false;
  totalHolding = {} as HoldingsTotal;
  underlierHoldings: Holdings[] = [];
  hasUnderlierHoldings: boolean = false;
  filteredHolding: Holdings[];
  callHoldings: Holdings[] = [];
  hasCallHoldings: boolean = false;
  putHoldings: Holdings[] = [];
  hasPutHoldings: boolean = false;
  language: string = '';


  constructor(private tradingService: TradingService, @Optional() @Inject('AppSettings') appSettings: any) {
    if (appSettings?.language) {
      this.language = appSettings.language;
      if (this.language === 'es') {
         registerLocaleData( es );
      }
  }
   }

  ngOnInit() {
    this.accountSub = this.tradingService.accountSubject$.subscribe((acct: Account) => {
      this.clearHoldingsData();
      this.account = acct;
      this.fetchHoldings();
    });
    const theSubject = this.isForSecondSymbol ? this.tradingService.secondSymbolSubject$ : this.tradingService.symbolSubject$;
    this.symbolSub = theSubject.subscribe((symIds: string[]) => {
      this.clearHoldingsData();
      this.symbols = [];

      if (!!symIds && symIds.length > 0) {
        for ( let symbol of symIds ) {
          this.symbols.push(symbol.trim().toUpperCase());
        }

        this.processHoldings();
      }
    });
  }

  fetchHoldings(): void {
    this.hasError = false;
    if (this.platform && this.account.acctNum) {
      this.tradingService.holdingsLoadInProgress = true;
      this.holdingSub = this.tradingService.getHoldings(this.platform, this.account.acctNum, this.account.firmAccount).subscribe(
        data => this.holdingsSuccessCallback(data),
        error => this.holdingsErrorCallback(error),
        () => this.holdingsCompleteCallback()
      );
    }
  }

  holdingsSuccessCallback(resp) {
    if (resp.errorCode === 0 && resp.response) {
      this.positions = resp.response.positions;
      this.tradingService.holdingSubject$.next(this.positions);
      if (this.symbols.length > 0) {
        this.processHoldings();
      }
    } else {
      this.hasError = true;
      console.log('server resp error in HoldingsMiniComponent:', resp);
    }
  }

  holdingsErrorCallback(err) {
    this.hasError = true;
    console.log('fetchHoldings() error - ', err);
    // when the error callback is invoked, complete is not, so we need to ensure that still is handled
    this.holdingsCompleteCallback();
  }

  private holdingsCompleteCallback(): void {
      this.tradingService.holdingsLoadInProgress = false;
      this.tradingService.holdingLoadCompleteSubject$.next({loadComplete: true});
  }

  processHoldings() {
    if (!!this.positions && Array.isArray(this.positions) && this.positions.length > 0) {
      this.positionsForDisplay = this.positions.filter((p) => this.symbolsContains(p.symbol && p.symbol.trim().toUpperCase()));
      this.updateHoldings();
      if (this.hasUnderlierHoldings && this.underlierHoldings.length > 0) {     
        this.handleMarketValue();
      }
    }
  }
  private   handleMarketValue(){
    let quantity: number = 0;
    let marketValue: number = 0;
    let underlier = this.underlierHoldings;
    for (let i = 0; i < underlier.length; i++) {
      let marketValueNum = this.showMktValInPositionCcy ? +underlier[i].marketValuePositionCcy : +underlier[i].marketValueBaseCcy;
      quantity = quantity + underlier[i].tradeDateQuantity;
      if (marketValueNum && !isNaN(marketValueNum)) {
        marketValue = marketValue + marketValueNum;
      }
    }
    this.totalHolding.tradeDateQuantity = quantity;
    this.totalHolding.marketValue = marketValue;
  }
  private symbolsContains(testSymbol: string): boolean {
    if ( this.symbols.length === 1 && this.symbols[0].indexOf(' ') > 0 && this.symbols[0].indexOf(' C ') === -1 && this.symbols[0].indexOf(' P ') === -1 ) {
      // symbols has an equity symbol with space and no secondary option root version provided; see if the test symbol matches either
      // symbols[0] or that value with the space stripped out. This will ensure we correctly show any option holdings for this equity.
      let baseSym = this.symbols[0];
      let altSym = baseSym.substring(0, baseSym.indexOf(' ')) + baseSym.substring(baseSym.indexOf(' ') + 1);

      return testSymbol === baseSym || testSymbol === altSym;
    } else {
      return testSymbol === this.symbols[0] || testSymbol === this.symbols[1];
    }
  }

      // clears all data on new symbol selection
      clearHoldingsData(): void {
        this.hasUnderlierHoldings = false;
        this.underlierHoldings = [];
        this.hasCallHoldings = false;
        this.hasPutHoldings = false;
        this.underlierHoldings = [];
        this.callHoldings = [];
        this.putHoldings = [];
        this.filteredHolding = [];
        this.hasError = this.tradingService.holdingErrorSubject$ && this.tradingService.holdingErrorSubject$.value && this.tradingService.holdingErrorSubject$.value.hasError;
        this.symbols = [];
        this.totalHolding = {} as HoldingsTotal;
        // this.showTotal = false;
    }
    // checks the current item in holdings list are underLyer/call/puts and add to the list appropriately
    updateHoldings(): void {
      for ( let holding of this.positionsForDisplay ) {
        if (this._isCall(holding.symbol)) {
          this.callHoldings.push(holding);
          this.hasCallHoldings = true;
          this.showMktValInPositionCcy = false;
          this.valueCurrency = 'USD';
        } else if (this._isPut(holding.symbol)) {
          this.putHoldings.push(holding);
          this.hasPutHoldings = true;
          this.showMktValInPositionCcy = false;
          this.valueCurrency = 'USD';
        } else {  // some symbol with space like 'BRK A' is valid underlyer
          this.underlierHoldings.push(holding);
          this.hasUnderlierHoldings = true;

          if ( holding.positionCcy !== 'USD' ) {
              this.showMktValInPositionCcy = true;
              this.valueCurrency = holding.positionCcy;
          } else {
              this.showMktValInPositionCcy = false;
              this.valueCurrency = 'USD';
          }
        }
      }
    }
    // Checks if a holding is a call
    _isCall(symbol): boolean {
      return symbol.indexOf(' C ') > 0;
    }
    // Checks if a holding is a put
    _isPut(symbol): boolean {
      return symbol.indexOf(' P ') > 0;
    }
    // Checks if a holding is not an option
    _notOption(symbol): boolean {
      return !this._isCall(symbol) && !this._isPut(symbol);
    }

  ngOnDestroy(): void {
    if ( this.accountSub ) {
      this.accountSub.unsubscribe();
    }

    if ( this.symbolSub ) {
      this.symbolSub.unsubscribe();
    }

    if ( this.holdingSub ) {
      this.holdingSub.unsubscribe();
    }
  }

}
